import { render, staticRenderFns } from "./CommesaAnnotazioni.vue?vue&type=template&id=faef06c8&"
import script from "./CommesaAnnotazioni.vue?vue&type=script&lang=js&"
export * from "./CommesaAnnotazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports